import { render, staticRenderFns } from "./newReport.vue?vue&type=template&id=5f20f18d&"
import script from "./newReport.vue?vue&type=script&lang=ts&"
export * from "./newReport.vue?vue&type=script&lang=ts&"
import style0 from "./newReport.vue?vue&type=style&index=0&id=5f20f18d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports